import type { RoomTypeConfig } from '@/types/reports';
import { mergeClasses } from '@fluentui/react-components';
import { Flag16Filled } from '@fluentui/react-icons';
import { useRoomTypeLegendStyles } from './RoomTypeLegend.styles';

export interface RoomTypeLegendProps {
  roomTypes: RoomTypeConfig[];
  largeEventThreshold: number;
  largeEventLabel: string;
}

export const RoomTypeLegend = ({ roomTypes, largeEventLabel }: RoomTypeLegendProps) => {
  const styles = useRoomTypeLegendStyles();

  return (
    <div className={mergeClasses(styles.root, styles.rootResponsive)} data-testid="room-type-legend" role="list" aria-label="Room type legend">
      {roomTypes.map((rt) => (
        <div key={rt.name} className={styles.item} role="listitem">
          <span className={styles.swatch} style={{ backgroundColor: rt.color }} aria-hidden="true" />
          <span className={styles.label}>{rt.name}</span>
        </div>
      ))}
      <div className={styles.largeIndicator} data-testid="large-indicator" role="listitem">
        <Flag16Filled className={styles.largeText} aria-hidden="true" />
        <span className={styles.largeText}>LARGE</span>
        <span className={styles.largeThreshold}>{largeEventLabel}</span>
      </div>
    </div>
  );
};

RoomTypeLegend.displayName = 'RoomTypeLegend';
